import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b1f738886e100014e91595/hkbeiyu/src/app/register/page.tsx");
